const abTranslate = require('./abTranslate-runtime');

angular.module('wix.ab-translate', []) // eslint-disable-line no-undef
  .provider('abTranslate', () => {
    return {
      abTranslate,
      $get: abTranslate
    };
  });
